import { api } from '@/services'
import { realEstateCheck } from './realEstate'
import { roleCheckAndRedirect } from './roleCheckAndRedirect'
import store from '@/store'

/*
  The parameter received by the function is only
  to check if we need to make the redirection or
  just update the user status. Can be a boolean or a string
*/

export const getUser = (updateState) =>
  api
    .get('/web/user/current')
    .then(({ data }) => {
      store.commit('setUser', data)
      localStorage.setItem('old_token', data?.api_token)
      localStorage.setItem('users_branch_id', data?.branch?.id)
      localStorage.setItem('users_branch_name', data?.branch?.name)
      localStorage.setItem('users_branch_address', data?.branch?.address)
      localStorage.setItem('users_real_estate_cnpj', data?.real_estate?.cnpj)
      localStorage.setItem('users_real_estate_id', data?.real_estate?.id)
      localStorage.setItem('users_onboard_status', data?.real_estate?.onboarding_status)
      localStorage.setItem('users_real_estate_subscription_type', data?.real_estate?.subscription_type ?? '')
      localStorage.setItem('user_contract_status', data?.user_contract_status?.contract_status)
      localStorage.setItem('user_country', data?.country)
      localStorage.setItem('user_language', data?.language)
      localStorage.setItem('user_currency', data?.currency)
      localStorage.setItem('has_partner', !!data?.real_estate?.partner)

      if (data?.logo_url) {
        localStorage.setItem('user_logo_url', data?.logo_url)
      } else {
        localStorage.removeItem('user_logo_url')
      }
    })
    .then(() => realEstateCheck())
    .then(() => !updateState && roleCheckAndRedirect())
    .catch((error) => {
      store.commit('setIsLoading', false)

      error.data
        ? store.dispatch('showErrorMessage', error.data.message)
        : store.dispatch('showErrorMessage', error.message)
    })
